import LoginSection from "../components/header/LoginSection";
import HeaderButtonComponent from "../components/header/HeaderButtonComponent";
import RightArrowIcon from "../../assets/icons/header-icons/right-arrow-white.svg";
import { useNavigate } from "react-router-dom";
import { HOME_ROUTE, useAppSelector } from "@hypexone/uicore";
import { getEnvVariable } from "../../constants/brandConfig";
import { domain } from "../../constants/Branding";
import androidIcon from "../../assets/icons/android-icon.svg";
import downloadIcon from "../../assets/icons/download-icon.svg";
import useOtpLogin from "./useOtpLogin";

const modalCloseHandler = () => {};

const MobileLoginPage = () => {
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const otpLoginEnabled = window.location.pathname.startsWith("/account/auth/");
  const logoUrl = sessionStorage.getItem("brandLogo") || "";

  useOtpLogin(
    modalCloseHandler,
    otpLoginEnabled ? window.location.pathname : undefined
  );

  const handleDownloadApk = () => {
    if (!apkUrl) return;
    const href = apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
    const link = document.createElement("a");
    link.href = href;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-gradient-to-r from-primary via-secondary to-teritary">
      <div className="pointer-events-none absolute inset-0 bg-black/20" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/25" />

      <div className="relative z-10 flex min-h-screen w-full flex-col p-4">
        <div>
          <HeaderButtonComponent
            leftIcon={{
              src: RightArrowIcon,
              alt: "right-arrow",
              customClassName: "h-2.5 w-2.5 scale-x-[-1]",
            }}
            onClick={() => navigate(HOME_ROUTE)}
            buttonText={langData?.["back"]}
          />
        </div>

        <div className="flex flex-1 flex-col items-center justify-center py-6">
          <img
            src={logoUrl ? logoUrl : getEnvVariable(domain, "logo")}
            alt="logo"
            className="h-auto max-h-[50px] w-auto cursor-pointer"
            onClick={() => navigate(HOME_ROUTE)}
          />

          {!otpLoginEnabled ? (
          <div className="w-full max-w-sm md:max-w-md rounded-xl border border-white/15 bg-black/25 shadow-[0_12px_40px_rgba(0,0,0,0.25)] backdrop-blur-sm overflow-hidden flex flex-col">
            <div className="p-5 md:p-6">
              <LoginSection isMobileScreen />
            </div>
            {apkUrl && (
              <button
                type="button"
                className="w-full h-[40px] shrink-0 bg-[#66bb6a] text-white font-bold flex items-center justify-center gap-2.5 text-sm cursor-pointer hover:opacity-90 transition-opacity"
                onClick={handleDownloadApk}
              >
                <img src={androidIcon} alt="" className="h-5 w-5 flex-shrink-0" />
                <span>Download .apk</span>
                <img src={downloadIcon} alt="" className="h-5 w-[10px]" />
              </button>
            )}
          </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MobileLoginPage;
